<template>
  <validation-provider :name="label || ' '" :vid="fieldUid" v-slot="validationContext" :rules="rules">
    <b-form-group
      :id="fieldUid"
      :label="label"
      :label-for="'input-' + fieldUid"
      :label-cols="labelcols"
      :content-cols="contentcols ? contentcols : undefined"
    >
      <b-form-input
        :id="'input-' + fieldUid"
        :placeholder="placeholder"
        v-model="form[name]"
        :state="getValidationState(validationContext)"
        :aria-describedby="fieldUid + '-live-feedback'"
        :type="type ? type : 'text'"
        :disabled="disabled"
        @change="onChangeInternal($event)"
        :step="step ? step : ''"
        :min="min ? min : ''"
        :max="max ? max : ''"
      ></b-form-input>
      <b-form-invalid-feedback :id="fieldUid + '-live-feedback'">{{
        validationContext.errors[0]
      }}</b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
export default {
  name: "TextComponent",
  props: [
    "form",
    "name",
    "label",
    "rules",
    "type",
    "placeholder",
    "disabled",
    "labelcols",
    "contentcols",
    "step",
    "min",
    "max",
    "uid",
  ],
  computed: {
    fieldUid() {
      return this.uid || this.name;
    },
  },
  data() {
    return {
      selectedItem: null,
    };
  },
  methods: {
    onChangeInternal($event) {
      this.$emit("onChange", $event);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
